export const unitTypes = {
  km: "km",
  miles: "miles"
}

export const distanceConstants = {
  MILES: 1609.34,
  KM: 1000
};

export const markersAction = {
  ALL: 'ALL'
}